import Vue from 'vue';
import Router from 'vue-router';
import vuejsDatepicker from 'vuejs-datepicker';

/**
 * Middlewares
 */
import NoAuth from '@/middlewares/noAuth';
import Auth from '@/middlewares/auth';

// Routes
import superadmin from './superadmin';
import distributor from './distributor';
import reseller from './reseller';
import customer from './customer';

// Helpers
Vue.component('pagination', () => import('@/components/Pagination.vue'));

// Vue.component('loading',() => import('@/components/helpers/Loading.vue'));
Vue.component('spinner', () => import('@/components/Spinner.vue'));
Vue.component('logoutspinner', () => import('@/components/LogoutSpinner.vue'));
Vue.component('loading', () => import('@/components/Loading.vue'));
Vue.component('snackbar', () => import('@/components/Snackbar.vue'));
Vue.component('app-modal', () => import('@/components/CustomModal.vue'));
Vue.component('app-pdf-viewer', () => import('@/components/PdfModal.vue'));
Vue.component('vuejs-datepicker', vuejsDatepicker);

// // Partials
Vue.component('app-header', () => import('@/components/inc/Header.vue'));
Vue.component('app-footer', () => import('@/components/inc/Footer.vue'));
Vue.component('dashboard-menu', () => import('@/components/inc/DashboardMenu.vue'));

// Superadmin partials
Vue.component('superadmin-sidebar', () => import('@/views/superadmin/Sidebar.vue'));
Vue.component('superadmin-breadcrumb', () => import('@/views/superadmin/BreadCrumb.vue'));

// Reseller partials
Vue.component('distributor-sidebar', () => import('@/views/distributor/Sidebar.vue'));
Vue.component('distributor-breadcrumb', () => import('@/views/distributor/BreadCrumb.vue'));

// Reseller partials
Vue.component('reseller-sidebar', () => import('@/views/reseller/Sidebar.vue'));
Vue.component('reseller-breadcrumb', () => import('@/views/reseller/BreadCrumb.vue'));

// Customer partials
Vue.component('customer-sidebar', () => import('@/views/customer/Sidebar.vue'));
Vue.component('customer-breadcrumb', () => import('@/views/customer/BreadCrumb.vue'));

// SN
Vue.component('serial-and-model', () => import('@/components/SerialAndModelNumber.vue'));

// Product Component
Vue.component('productItem', () => import('@/components/ProductItem.vue'));
Vue.component('customerItem', () => import('@/components/CustomerItem.vue'));
Vue.component('resellerItem', () => import('@/components/ResellerItem.vue'));
Vue.component('distributorItem', () => import('@/components/DistributorItem.vue'));

Vue.component('file-uploader', () => import('@/components/FileUploader.vue'));
Vue.component('custom-check-box', () => import('@/components/CustomCheckBox.vue'));

Vue.use(Router);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/404',
            addtoNav: false,
            name: 'PageNotFound',
            component: () => import('@/views/404.vue')
        },

        /**
         * Login route
         */
        {
            path: '/',
            component: () => import('@/views/Login.vue'),
            name: 'Login',
            addtoNav: false,
            meta: {
                navText: 'Login',
                middleware: [NoAuth]
            }
        },

        /**
         * Login route
         */
        {
            path: '/reset-password',
            component: () => import('@/views/ResetPassword.vue'),
            name: 'ResetPassword',
            addtoNav: false,
            meta: {
                navText: 'ResetPassword',
                middleware: [NoAuth]
            }
        },

        {
            path: '/verify-email',
            component: () => import('@/views/VerifyEmail.vue'),
            name: 'VerifyEmail',
            addtoNav: false,
            meta: {
                navText: 'VerifyEmail',
                middleware: [NoAuth]
            }
        },

        ...superadmin,

        ...distributor,

        ...reseller,

        ...customer,

        /**
         * Default layouts
         */

        {
            path: '/edit-profile',
            component: () => import('@/views/EditProfile.vue'),
            name: 'EditProfile',
            addtoNav: false,
            meta: {
                navText: 'Edit Profile',
                middleware: [Auth]
            }
        },

        {
            path: '*',
            addtoNav: false,
            name: '404',
            component: () => import('@/views/404.vue')
        }
    ]
});
